import*as e from"react";function u(t){let c=e.useRef(t);return e.useEffect(()=>{c.current=t}),e.useMemo(()=>(...r)=>c.current?.(...r),[])}export{u as a};
